<div class="m-3">
    <!-- header Section -->
    <div class="row bg-light ">
        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 addImage">
            <h2 class="text-center pt-9 pb-3 mb-0 fw-bold display-4" >Plan Details</h2>
        </div>
    </div>
    <div class="row">
        <!-- FAQ SECTION -->
        <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6 bg-white">
            <h1 class="fw-bold display-6 fs-4">Frequently Asked Questions</h1>

            <!-- First Question -->
      <div class="accordion m-1" id="accordionPanelsStayOpenFirstExample" >
        <div class="accordion-item m-1" [ngClass]="{'show': isDropdownOpen}"[ngStyle]="{'background-color': isDropdownOpen ?' #590FFA':'white','color':'white'}">
          <h4 class="accordion-header" id="panelsStayOpen-headingFirst" style="margin: 0px!important;">
            <button class="accordion-button text-black" type="button" data-bs-toggle="collapse"  [ngClass]="{'show': isDropdownOpen}"
            [ngStyle]="{'background-color': isDropdownOpen ?' #590FFA':'white','color':'white'}"
              data-bs-target="#panelsStayOpen-collapseFirst" aria-expanded="true"
              aria-controls="panelsStayOpen-collapseFirst">
              <span class = "dropdownLabel">
                <h5 class="fs-1 fw-bold" style="color: white;">What forms of payment do you accept?</h5>
              </span>
            </button>
          </h4>
          <div id="panelsStayOpen-collapseFirst" class="accordion-collapse collapse"  [ngClass]="{'show': isDropdownOpen}"      
          [ngStyle]="{'background-color': isDropdownOpen ?' #590FFA' :'white','color':'white'}"
            aria-labelledby="panelsStayOpen-headingFirst" data-bs-parent="#accordionPanelsStayOpenFirstExample">
            <div class="accordion-body m-3">
                <p class="fs--1">
                    You can purchase iCeipts  with any major credit card. For annual subscriptions, we can issue
                    an invoice payable by bank transfer or check. Please contact us to arrange an invoice
                    purchase. Monthly purchases must be paid for by credit card.
                </p>
            </div>
          </div>
        </div>
      </div>

      
            <!-- Second Questiuon -->
            <div class="accordion ml-1 mr-1" id="accordionPanelsStayOpenTwoExample">
                <div class="accordion-item m-1">
                  <h4 class="accordion-header" id="panelsStayOpen-headingTwo" style="margin: 0px!important;">
                    <button class="accordion-button text-black" type="button" data-bs-toggle="collapse"
                      data-bs-target="#panelsStayOpen-collapseTwo" aria-expanded="true"
                      aria-controls="panelsStayOpen-collapseTwo">
                      <span class = "dropdownLabel">
                      <h5 class="fs-1 fw-bold text-black">
                        We need to add more people to our team. How will that be billed?
                    </h5>
                    </span>
                    </button>
                  </h4>
                  <div id="panelsStayOpen-collapseTwo" class="accordion-collapse collapse"
                    aria-labelledby="panelsStayOpen-headingTwo" data-bs-parent="#accordionPanelsStayOpenTwoExample">
                    <div class="accordion-body m-3">
                        <p class="fs--1">
                            You can add as many new teammates as you need before changing your subscription. We will
                            subsequently ask you to correct your subscription to cover current usage.
                        </p>
                    </div>
                  </div>
                </div>
              </div>



                <!--Third Questiuon -->
            <div class="accordion ml-1 mr-1" id="accordionPanelsStayOpenThirdExample">
                <div class="accordion-item m-1">
                  <h4 class="accordion-header" id="panelsStayOpen-headingThird" style="margin: 0px!important;">
                    <button class="accordion-button text-black" type="button" data-bs-toggle="collapse"
                      data-bs-target="#panelsStayOpen-collapseThird" aria-expanded="true"
                      aria-controls="panelsStayOpen-collapseThird">
                      <span class = "dropdownLabel">
                      <h5 class="fs-1 fw-bold text-black">
                        Will I be charged sales tax?
                    </h5>
                      </span>
                    </button>
                  </h4>
                  <div id="panelsStayOpen-collapseThird" class="accordion-collapse collapse"
                    aria-labelledby="panelsStayOpen-headingThird" data-bs-parent="#accordionPanelsStayOpenThirdExample">
                    <div class="accordion-body m-3">
                        <p class="fs--1">
                            As of May 2016, state and local sales tax will be applied to fees charged to customers with
                            a billing address in the State of New York.
                        </p>
                    </div>
                  </div>
                </div>
              </div>




              <!-- Four question -->
                           <div class="accordion ml-1 mr-1" id="accordionPanelsStayOpenFourExample">
                <div class="accordion-item m-1">
                  <h4 class="accordion-header" id="panelsStayOpen-headingFour" style="margin: 0px!important;">
                    <button class="accordion-button text-black" type="button" data-bs-toggle="collapse"
                      data-bs-target="#panelsStayOpen-collapseFour" aria-expanded="true"
                      aria-controls="panelsStayOpen-collapseFour">
                      <span class = "dropdownLabel">
                      <h5 class="fs-1 fw-bold text-black">
                        Do you offer discounts?
                    </h5>
                    </span>
                    </button>
                  </h4>
                  <div id="panelsStayOpen-collapseFour" class="accordion-collapse collapse"
                    aria-labelledby="panelsStayOpen-headingFour" data-bs-parent="#accordionPanelsStayOpenFourExample">
                    <div class="accordion-body m-3 ">
                        <p class="fs--1">
                            We've built in discounts at each tier for teams smaller than 15 members. We also offer two
                            months for free in exchange for an annual subscription.
                        </p>
                    </div>
                  </div>
                </div>
              </div>


               <!-- Five question -->
               <div class="accordion ml-1 mr-1" id="accordionPanelsStayOpenFiveExample">
                <div class="accordion-item m-1">
                  <h4 class="accordion-header" id="panelsStayOpen-headingFive" style="margin: 0px!important;">
                    <button class="accordion-button text-black" type="button" data-bs-toggle="collapse"
                      data-bs-target="#panelsStayOpen-collapseFive" aria-expanded="true"
                      aria-controls="panelsStayOpen-collapseFive">
                       <span class = "dropdownLabel">
                      <h5 class="fs-1 fw-bold text-black">
                        Do you offer academic pricing?
                    </h5>
                    </span>
                    </button>
                  </h4>
                  <div id="panelsStayOpen-collapseFive" class="accordion-collapse collapse"
                    aria-labelledby="panelsStayOpen-headingFive" data-bs-parent="#accordionPanelsStayOpenFiveExample">
                    <div class="accordion-body m-3 ">
                        <p class="fs--1">
                            We're happy to work with student groups using iCeipts . Contact Us
                        </p>
                    </div>
                  </div>
                </div>
              </div>
        

               <!-- six question -->
               <div class="accordion ml-1 mr-1" id="accordionPanelsStayOpensixExample">
                <div class="accordion-item m-1">
                  <h4 class="accordion-header" id="panelsStayOpen-headingsix" style="margin: 0px!important;">
                    <button class="accordion-button text-black" type="button" data-bs-toggle="collapse"
                      data-bs-target="#panelsStayOpen-collapsesix" aria-expanded="true"
                      aria-controls="panelsStayOpen-collapsesix">
                      <span class = "dropdownLabel">
                      <h5 class="fs-1 fw-bold text-black">
                        What is your refund policy?
                    </h5>
                      </span>
                    </button>
                  </h4>
                  <div id="panelsStayOpen-collapsesix" class="accordion-collapse collapse"
                    aria-labelledby="panelsStayOpen-headingsix" data-bs-parent="#accordionPanelsStayOpensixExample">
                    <div class="accordion-body m-3">
                        <p class="fs--1">
                            We do not offer refunds apart from exceptions listed below. If you cancel your plan before
                            the next renewal cycle, you will retain access to paid features until the end of your
                            subscription period. When your subscription expires, you will lose access
                            to paid features and all data associated with those features. Exceptions to our refund
                            policy: canceling within 48 hours of initial charge will result in a full refund. If you
                            cancel within this timeframe, you will lose access
                            to paid features and associated data immediately upon canceling.                        </p>
                    </div>
                  </div>
                </div>
              </div>
        
        

        

        





        </div>


        <!-- payment section -->
        <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6 bg-light">
            <div class="card bg-white">
                <div class="card-body">
                    <!-- details of personals plans  -->
                    <div class="planDetails">
                        <div class="row">
                            <div class="col-md-12 col-sm-12 col-xl-12 col-lg-12 ">
                                <p class="fw-bold m-2">{{this.submitObj?.firstName}}</p>
                                <p class="text-gray m-2">{{this.submitObj?.email}}</p>
                                <p class="text-gray  m-2">{{this.submitObj?.phone}}</p>

                            </div>
                        </div>
                        <div class="row m-2">
                            <div class="col-sm-12 col-md-6 col-xl-6 col-lg-6">
                                <p><input type="radio" checked> <span class="m-2">{{this.planName}}</span></p>
                                <p class="text-danger  m-2">save 39%</p>
                            </div>
                            <div class="col-sm-12 col-md-6 col-xl-6 col-lg-6 text-end">
                            
                                <p class="fw-bold textColorAED"> <span style="text-decoration: line-through;padding-right: 3px;">
                                  {{ this.totalAmount * 1.5  | number:'1.2-2'}}
                                </span><span> </span>{{this.totalAmount}}-<span
                                        class="fw-normal text-black">{{this.validity}} Days</span></p>
                                        <p><b class="text-black">{{ (this.totalAmount / 12) | number:'1.2-2' }}</b>/Month</p>
                            </div>
                        </div>
                    </div>
                    <!-- For checkbox -->
                    <!-- <div class="row mt-3">
                        <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12">
                            <p><input type="checkbox"><span class="m-2">
                                    Recurring Payement- Subscription will be auto generated <b class="textColorAED">₹
                                        {{this.totalAmount}}</b> on every <b>30 days</b> until cancelled</span></p>
                        </div>
                    </div> -->
                    <p class="m-2 text-black"><b>Plan Details</b></p>
                    <!-- For table -->
                    <div class="row mt-3">
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xl-12">
                            <table class="table table-bordered table-stripped fs--1 m-2  table-responsive ">
                                <thead>
                                    <tr class="text-black">
                                        <th>Feature</th>
                                        <th>price</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let feature of features;let i=index"
                                    style="color: #676398!important;"
                                    [ngStyle]="{'background-color':(i % 2 === 0 ? '#ffffff' : '#f2f2f2')}">
                                        <td>{{feature.featureName|titlecase}}</td>
                                        <td>{{feature.price * (this.validity / 30)  | number:'1.2-2' }}</td>
                                    </tr>
                                    <tr>
                                        <th class="text-end text-black"><b>Grand Total</b></th>
                                        <th class="text-black"><b>{{totalAmount}}</b></th>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>


                    <!-- for pay -->
                    <div class="row">
                        <div class="col-lg-12 col-xl-12 col-md-12 col-sm-12">
                            <div class="col-md-12 text-center">
                                <div class=" h-100 bg-white text-dark">
                                    <div class="">
                                        <!-- <h5 class="mb-0">Payment Form</h5> -->
                                    </div>

                                    <div class="">
                                        <form ngNoForm [action]='url' method='post'>
                                            <div *ngIf="this.submitObj != null">
                                                <!-- <input class="form-control" type="text" name="service_provider" value="payu_paisa"> -->
                                                <input class="form-control" type="hidden" name="key"
                                                    [(ngModel)]="this.submitObj.key" />
                                                <input class="form-control" type="hidden" name="txnid"
                                                    [(ngModel)]="this.submitObj.txnId" />
                                                <input class="form-control" type="hidden" (keyup)="setHash()"
                                                    name="productinfo" [(ngModel)]="this.planName" />
                                                <input class="form-control" type="hidden" (keyup)="setHash()"
                                                    name="amount" [(ngModel)]="this.totalAmount" />
                                                <input class="form-control" type="hidden" (keyup)="setHash()"
                                                    name="email" [(ngModel)]="this.submitObj.email" />
                                                <input class="form-control" type="hidden" (keyup)="setHash()"
                                                    name="firstname" [(ngModel)]="this.submitObj.firstName" />
                                                <input class="form-control" type="hidden" (keyup)="setHash()"
                                                    name="lastname" [(ngModel)]="this.submitObj.lastName" />
                                                <input type="hidden" class="form-control" type="hidden" name="surl"
                                                    [(ngModel)]="this.submitObj.surl" />
                                                <input type="hidden" class="form-control" type="hidden" name="furl"
                                                    [(ngModel)]="this.submitObj.furl" />
                                                <input class="form-control" type="hidden" (keyup)="setHash()"
                                                    name="phone" [(ngModel)]="this.submitObj.phone">
                                                <input type="hidden" class="form-control" type="hidden"
                                                    [(ngModel)]="this.submitObj.udf1" name="udf1">
                                                <input type="hidden" class="form-control" type="hidden"
                                                    [(ngModel)]="this.submitObj.udf2" name="udf2">
                                                <input type="hidden" class="form-control" type="hidden"
                                                    [(ngModel)]="this.submitObj.udf3" name="udf3">
                                                <input type="hidden" class="form-control" placeholder="Enter Number"
                                                    type="hidden" name="hash" [(ngModel)]="this.submitObj.hash" />
                                                    <div class="button-container">
                                                <input class="btn btn-save mt-3" type="submit" value="Proceed to Pay">
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>